import Vue from 'vue';
import _ from 'lodash';
import { DateTime } from 'luxon';
import { createActionHelpers } from 'vuex-loading';

export const CLEAR_MODULE = 'clearMenuInversoresModule';
export const SET_LOADING = 'setLoadingMenuInversores';
export const UPSERT_ENTITY = 'upsertEntityMenuInversores';
export const REMOVE_ENTITY = 'removeEntityMenuInversores';
export const SEARCH = 'searchMenuInversores';
export const SEARCH_SUCCESS = 'searchMenuInversoresSuccess';
export const UPDATE_CESIONES_MAP = 'updateCesionesMap';
export const UPDATE_INVERSORES_MAP = 'updateInversoresMap';
export const UPDATE_FIND_RESULT = 'updateFindResult';

export const submitSearchInversoresAction = 'submitSearchInversoresAction';
export const recreateInversoresMapsAction = 'recreateInversoresMapsAction';
export const createInversorAction = 'createInversorAction';
export const updateInversorAction = 'updateInversorAction';
export const removeInversorAction = 'removeInversorAction';
export const searchByFilterAction = 'searchByFilterAction';
export const resetSearchAction = 'resetSearchAction';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});

function buildInversoresMap(cesiones) {
  const result = {};
  _.forOwn(cesiones, (cesion) => {
    if (cesion.inversor && cesion.inversor !== '') {
      if (!result[cesion.inversor]) {
        result[cesion.inversor] = [];
      }
      if (result[cesion.inversor].indexOf(cesion.id) === -1) {
        result[cesion.inversor].push(cesion.id);
      }
    }
  });
  return result;
}
function calcularVencimiento(operation, dates, plazos) {
  let tipoPlazoActual;
  let plazoActual;
  let fecha;
  if (plazos && operation.plazo) {
    tipoPlazoActual = plazos.filter(p => p.uuid === operation.plazo);
    plazoActual = operation.plazoNumero ? operation.plazoNumero : 0;
    if (tipoPlazoActual[0] && plazoActual) {
      fecha = DateTime.fromISO(dates.fechaFirmaNotario);
      switch (tipoPlazoActual[0].text) {
        case 'meses':
          fecha = fecha.plus({ months: plazoActual });
          break;
        case 'años':
          fecha = fecha.plus({ years: plazoActual });
          break;
        case 'días':
          fecha = fecha.plus({ days: plazoActual });
          break;
        default:
          break;
      }
    }
  }
  return fecha;
}
function buildCesionesMap(operaciones) {
  const result = {};
  _.forOwn(operaciones, (operacion) => {
    if (Array.isArray(operacion.cesiones)) {
      operacion.cesiones.forEach((cesion) => {
        result[cesion] = operacion.id;
      });
    }
  });
  return result;
}
function filterInversorByVencimiento(inversores, dates, plazos) {
  inversores.forEach((entity) => {
    if (entity.operation && entity.operation.datesAssigments) {
      entity.operation.fechaVencimiento = calcularVencimiento(entity.operation, dates[entity.operation.datesAssigments], plazos);
    }
  });
  const actualDay = new Date();
  const actualDateTime = DateTime.fromObject(actualDay);
  inversores.filter((entity) => {
    if (entity.operation && entity.operation.fechaVencimiento) {
      entity.diff = entity.operation.fechaVencimiento.diff(actualDateTime, 'minutes');
      if (entity.diff && entity.diff.values && entity.diff.values.minutes) {
        return entity.diff.values.minutes > 0;
      }
    }
    return entity;
  });
  return inversores;
}
async function proyectInversoresCesionesOperation(commit, getters, rootGetters, inversores) {
  const cesiones = await rootGetters['cesion_model/entitiesGetter'];
  const operaciones = await rootGetters['operation_model/entitiesGetter'];
  const cesionesMap = await getters.cesionesMap;
  const inversoresMap = await getters.inversoresMap;
  commit(UPDATE_CESIONES_MAP, cesionesMap);
  commit(UPDATE_INVERSORES_MAP, inversoresMap);
  const result = [];
  if (Array.isArray(inversores)) {
    inversores.forEach((inversor) => {
      if (Array.isArray(inversoresMap[inversor.id]) && inversoresMap[inversor.id].length > 0) {
        inversoresMap[inversor.id].forEach(cesion => result.push({
          posicion: '',
          inversor,
          operation: operaciones[cesionesMap[cesion]],
          inversion: cesiones[cesion].importe,
          cesion: cesiones[cesion],
        }));
      } else {
        result.push({
          posicion: '',
          inversor,
          operation: null,
          inversion: 0,
        });
      }
    });
  }
  return result;
}

async function recreateMaps(commit, dispatch, rootGetters) {
  await dispatch('inversor_model/fetchAction', {}, { root: true });
  await dispatch('cesion_model/fetchAction', {}, { root: true });
  await dispatch('operation_model/fetchAction', {}, { root: true });
  const cesiones = await rootGetters['cesion_model/entitiesGetter'];
  const operaciones = await rootGetters['operation_model/entitiesGetter'];
  const cesionesMap = buildCesionesMap(operaciones);
  const inversoresMap = buildInversoresMap(cesiones);
  commit(UPDATE_CESIONES_MAP, cesionesMap);
  commit(UPDATE_INVERSORES_MAP, inversoresMap);
}

const initState = {
  error: '',
  loading: false,
  findResult: false,
  inversores: [],
  inversoresData: {},
  filters: {},
  results: [],
  searching: false,
  cesionesMap: {},
  inversoresMap: {},
};

export default {
  namespaced: true,
  state: initState,
  mutations: {
    [CLEAR_MODULE](state) {
     // Object.assign(state, Vue._.cloneDeep(initState));
      Object.assign(state, initState);
    },
    [SET_LOADING](state, payload) {
      Vue.set(state, 'loading', payload);
    },
    [UPSERT_ENTITY](state, payload) {
      state.results.splice(0, 0, [payload]);
    },
    [UPDATE_CESIONES_MAP](state, payload) {
      state.cesionesMap = payload;
    },
    [UPDATE_INVERSORES_MAP](state, payload) {
      state.inversoresMap = payload;
    },
    [REMOVE_ENTITY](state, payload) {
      const { entity } = payload;
      if ('id' in entity && entity.id !== '') {
        const position = state.inversores.indexOf(entity.id);
        if (position > -1) {
          Vue.delete(state.inversoresData, entity.id);
          state.inversores.splice(position, 1);
        }
      }
    },
    [SEARCH](state) {
      state.searching = true;
    },
    [SEARCH_SUCCESS](state, payload) {
      if (Array.isArray(payload)) {
        state.results = payload;
      }
      state.searching = false;
    },
    [UPDATE_FIND_RESULT](state, payload) {
      state.findResult = payload;
    },
  },
  actions: {
    [submitSearchInversoresAction]({ commit, dispatch, getters, rootGetters }, payload) {
      startLoading(dispatch, 'buscar inversor');
      commit(SEARCH);
      const fetchConfig = {};
      _.forOwn(payload, (value, key) => {
        if (value) {
          if (key === 'nombre') {
            fetchConfig.nombreFilter = {
              modelName: 'title',
              operator: 'CONTAINS',
              value,
              path: 'title',
            };
          } else if (key === 'dni') {
            fetchConfig.dniFilter = {
              modelName: 'dni',
              operator: 'CONTAINS',
              value,
              path: 'dni_inversor',
            };
          } else if (key === 'importeMinimo') {
            fetchConfig.importeMinimoFilter = {
              operator: '>=',
              value,
              path: 'importe_inversion',
              parent: 'node--cesion',
              parentProperty: 'inversor',
            };
          } else if (key === 'importeMaximo') {
            fetchConfig.importeMaximoFilter = {
              operator: '<=',
              value,
              path: 'importe_inversion',
              parent: 'node--cesion',
              parentProperty: 'inversor',
            };
          }
        }
      });
      return dispatch(recreateInversoresMapsAction)
        .then(() => dispatch('inversor_model/fetchAction', fetchConfig, { root: true }))
        .then((response) => {
          proyectInversoresCesionesOperation(commit, getters, rootGetters, response.entities)
        .then(entities => commit(SEARCH_SUCCESS, entities))
        .then(() => commit(UPDATE_FIND_RESULT, true))
            .then(() => endLoading(dispatch, 'buscar inversor'));
        })
    .catch((error) => {
      dispatch('updateErrorOverlay', error, { root: true });
      endLoading(dispatch, 'buscar inversor');
    });
    },
    // eslint-disable-next-line consistent-return
    [searchByFilterAction]({ commit, dispatch, getters, rootGetters }, payload) {
      startLoading(dispatch, 'buscar inversor');
      const dates = rootGetters['datesAssignements_model/entitiesGetter'];
      const plazos = rootGetters['taxonomy/getTaxonomy']('date');
      const fetchConfig = {};
      switch (payload) {
        case 'Inversor activo':
          fetchConfig.uuid = {
            operator: 'IS NOT NULL',
            path: 'inversor.uuid',
            parent: 'node--cesion',
            parentProperty: 'inversor',
          };
          return dispatch(recreateInversoresMapsAction)
            .then(() => dispatch('inversor_model/fetchAction', fetchConfig, { root: true }))
            .then(results => proyectInversoresCesionesOperation(commit, getters, rootGetters, results.entities))
            .then((entities) => {
              if (entities.length <= 0) {
                commit(SEARCH_SUCCESS, entities);
              } else {
                entities = filterInversorByVencimiento(entities, dates, plazos);
                commit(SEARCH_SUCCESS, entities);
              }
              commit(UPDATE_FIND_RESULT, true);
              endLoading(dispatch, 'buscar inversor');
            })
            .catch((error) => {
              dispatch('updateErrorOverlay', error, { root: true });
              endLoading(dispatch, 'buscar inversor');
            });
        // eslint-disable-next-line no-case-declarations
        case 'Inversor inactivo':
          let inversores = [];
          fetchConfig.uuid = {
            operator: 'IS NOT NULL',
            path: 'inversor.uuid',
            parent: 'node--cesion',
            parentProperty: 'inversor',
          };
          dispatch('inversor_model/fetchAction', fetchConfig, { root: true })
             .then(results => proyectInversoresCesionesOperation(commit, getters, rootGetters, results.entities))
             .then((result) => {
               inversores = filterInversorByVencimiento(result, dates, plazos);
               dispatch('inversor_model/fetchAction', {}, { root: true })
                .then((inversoresTotales) => {
                  const inversoresArr = [];
                  const finalResult = [];
                  inversores.forEach(e => inversoresArr.push(e.inversor.id));
                  inversoresTotales.entities.forEach((e) => {
                    if (inversoresArr.indexOf(e.id) < 0) {
                      finalResult.push(e);
                    }
                  });
                  proyectInversoresCesionesOperation(commit, getters, rootGetters, finalResult)
                    .then(res => commit(SEARCH_SUCCESS, res))
                    .then(() => commit(UPDATE_FIND_RESULT, true))
                    .then(() => endLoading(dispatch, 'buscar inversor'));
                });
             })
            .catch((error) => {
              dispatch('updateErrorOverlay', error, { root: true });
              endLoading(dispatch, 'buscar inversor');
            });
          break;
        default:
          commit(SEARCH_SUCCESS, []);
          break;
      }
    },
    [createInversorAction]({ commit, dispatch }, payload) {
      return dispatch('inversor_model/upsertEntityAction', payload, { root: true })
        .then(res => commit(UPSERT_ENTITY, { entity: res }));
    },
    [updateInversorAction]({ dispatch }, payload) {
      return dispatch('inversor_model/upsertEntityAction', payload, { root: true });
    },
    [recreateInversoresMapsAction]({ commit, dispatch, rootGetters }) {
      return recreateMaps(commit, dispatch, rootGetters);
    },
    [removeInversorAction]({ dispatch }, payload) {
      return dispatch('inversor_model/upsertEntityAction', payload, { root: true });
    },
    [resetSearchAction]({ commit }) {
      commit(UPDATE_FIND_RESULT, false);
      commit(CLEAR_MODULE);
    },
  },
  getters: {
    inversoresTable: state => state.results,
    cesionesMap: state => state.cesionesMap,
    inversoresMap: state => state.inversoresMap,
    findResult: state => state.findResult,
  },
};



// WEBPACK FOOTER //
// ./src/features/menu-inversores/store.js